export default __webpack_public_path__ + "assets/6c07576cd19b13804331ef428f5324a9.png";